import { Colors } from '@vetahealth/fishing-gear/colors'
import {
  convert,
  defaultUnits,
  getDisplayValue,
  normalize,
  normalizedUnitRanges,
  normalizedUnits,
} from '@vetahealth/fishing-gear/conversions'
import { CardDetails } from '@vetahealth/tuna-can-api'
import i18next from 'i18next'

import { LineChart } from '../Chart/LineChart'
import { createAlertField, createDeviceField } from '../Table/helpers'
import { GetResultsConfigParams, ResultsConfig } from './types'

export function getBloodOxygenConfig({ userUnits }: GetResultsConfigParams): ResultsConfig {
  const unit = userUnits.bloodOxygen || defaultUnits.bloodOxygen

  const [min, max] = normalizedUnitRanges.bloodOxygen
  const [convertedMin] = convert(min, normalizedUnits.bloodOxygen, 'bloodOxygen', unit)
  const [convertedMax] = convert(max, normalizedUnits.bloodOxygen, 'bloodOxygen', unit)

  return {
    key: 'bloodOxygen',
    title: i18next.t('tracking.bloodOxygen.title'),
    category: 'tracking',
    unit,
    format: (event, targetUnit, omitUnit) =>
      event.value !== undefined
        ? getDisplayValue(
            [event.value, event.additionalValue ?? 0],
            event.unit ?? normalizedUnits.bloodOxygen,
            'bloodOxygen',
            { targetUnit, omitUnit },
          )
        : '–',
    actions: {
      add: [
        {
          key: 'value',
          label: i18next.t('tracking.bloodOxygen.bloodOxygen', { unit }),
          validators: [
            { required: true, message: i18next.t('validations.enterBloodOxygen') },
            {
              min,
              max,
              type: 'number',
              transform: (value) => normalize('bloodOxygen', Number(value), unit)[0],
              message: i18next.t('validations.trackingRange', {
                min: convertedMin,
                max: convertedMax,
                unit,
              }),
            },
          ],
        },
      ],
      reviewBulk: true,
      downloadCsv: true,
    },
    chart: {
      component: LineChart,
      intervals: ['day', 'week', 'month', 'trend'],
      dataKeys: [{ key: 'value', color: Colors.azure500 }],
      getData: (data: CardDetails[]) =>
        data.map((event) => ({
          ...event,
          value: convert(event.value, event.unit, 'bloodOxygen', unit)[0],
        })),
    },
    table: {
      defaultFields: true,
      additionalFields: [createAlertField(), createDeviceField()],
      actions: ['review', 'delete'],
    },
  }
}
